"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var bi_1 = require("react-icons/bi");
var styles_1 = require("./styles");
var TableSelectBox = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, select = _a.select, onClick = _a.onClick;
    var _c = __read(react_1.useState(select !== undefined ? select : false), 2), selected = _c[0], setSelected = _c[1];
    var handleSelected = react_1.useCallback(function (event) {
        if (disabled) {
            return;
        }
        setSelected(function (oldState) { return !oldState; });
        if (onClick)
            onClick(event);
    }, [onClick, disabled]);
    return (jsx_runtime_1.jsx(styles_1.Container, __assign({ className: "selectBoxTable", onClick: handleSelected, selected: selected }, { children: selected && jsx_runtime_1.jsx(bi_1.BiCheck, { size: 16, color: "fff" }, void 0) }), void 0));
};
exports.default = TableSelectBox;
//# sourceMappingURL=index.js.map